import variables from '@/assets/base/variables';

// Non-Blues
const royalPurple = '#AC3C86';
const selectiveYellow = '#FDBC04';
const coralOrange = '#F77A4A';
const green = '#00A63E';

// Blues
const royalBlue = '#157def'; // variables.$primitives-color-blue-300
const tropaz = '#224D92';
const mirage = '#1B1F3B';
const cerulean = '#10A4C4';
const waikawa = '#545A89'; // variables.$primitives-color-primary-500;
const jordy = '#99C0F5';

const chartColors = variables.tokens.color.charts;

const mekkoColors: string[] = [
  royalBlue,
  waikawa,
  tropaz,
  mirage,
  cerulean,
  selectiveYellow,
  royalPurple,
  coralOrange,
];

const mekkoTextColors: string[] = [
  '#FFFFFF',
  '#FFFFFF',
  '#FFFFFF',
  '#FFFFFF',
  '#FFFFFF',
  '#000000',
  '#FFFFFF',
  '#FFFFFF',
];

const pieColors: string[] = [
  royalBlue,
  tropaz,
  royalPurple,
  waikawa,
  cerulean,
  mirage,
  selectiveYellow,
  coralOrange,
];

const pieTextColors: string[] = [
  '#FFFFFF',
  '#FFFFFF',
  '#FFFFFF',
  '#FFFFFF',
  '#FFFFFF',
  '#FFFFFF',
  '#000000',
  '#FFFFFF',
];

const barColors: string[] = [
  royalBlue,
  jordy,
  coralOrange,
  waikawa,
  selectiveYellow,
  mirage,
  cerulean,
  royalPurple,
];

const barTextColors: string[] = [
  '#000000',
  '#000000',
  '#000000',
  '#000000',
  '#000000',
  '#000000',
  '#000000',
  '#000000',
];

// Color map for accessing colors by name
const colorMap: Record<string, string> = {
  royalPurple,
  selectiveYellow,
  coralOrange,
  royalBlue,
  tropaz,
  mirage,
  cerulean,
  waikawa,
  jordy,
  green,
};

// Function to get color by name
const getColorByName = (name: string): string => {
  return colorMap[name] ?? getColorByName('royalBlue');
};

// Function to get all available color names
const getColorNames = (): string[] => {
  return Object.keys(colorMap);
};

export {
  mekkoColors,
  mekkoTextColors,
  pieColors,
  pieTextColors,
  barColors,
  barTextColors,
  chartColors,
  // Functions to get colors by name
  getColorByName,
  getColorNames,
};
